module.exports = __webpack_public_path__ + "img/energy_yunxingjiance.a938007a.png";